import {FC} from 'react';
import OrganizationAllSocialItems from '@/components/Organization/SocialFormActions/AllSocialItems';
import {USER_TYPE} from '@/utils/enums';

const AllSocialItems: FC = () => {
	return <OrganizationAllSocialItems userType={USER_TYPE.USER} />;
};

export default AllSocialItems;
